import React, { useContext } from "react";
import { ProjectContext }    from "./ProjectProvider";
import { useNavigate }       from "react-router-dom";
import "./PopupErrors.css";

export default function PopupErrors() {
  const { errorPopup, closeErrorPopup } = useContext(ProjectContext);
  const navigate = useNavigate();

  if (!errorPopup) return null;

  const { msg, showBuy } = errorPopup;

  return (
    <div className="pe-backdrop" onClick={closeErrorPopup}>
      <div className="pe-card" onClick={e => e.stopPropagation()}>
        <button className="pe-close" onClick={closeErrorPopup}>
          <i className="bi bi-x-lg" />
        </button>

        <p className="pe-message">{msg}</p>

        {showBuy && (
          <button
            className="pe-buy-btn"
            onClick={() => {
              closeErrorPopup();
              navigate("/payment");
            }}
          >
            Go to packages
          </button>
        )}
      </div>
    </div>
  );
}
